import RateRow from './RateRow';

export default RateRow;
